import React, { useState} from "react";
import imgpurchase from "../Assets/images/steptodown.com787175.jpg";
import imgrepair from "../Assets/images/advisory.jpg";
import imgslider2 from "../Assets/images/verification.jpg";
import amcImage from "../Assets/images/excellence.jpg";
import bannerImage from "../Assets/randeva logos/svg.svg";
import { useNavigate } from "react-router-dom";
import Seo from "./Seo";




const About = ({ setActiveComponent }) => {
  // const [isSmallScreen, setIsSmallScreen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const handleNavItemClick = (path) => {
    navigate(`/${path}`);
    setIsOpen(false); // Close the navbar on item click for smaller screens
  };

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsSmallScreen(window.innerWidth <= 600); // Adjust the threshold as per your requirement
  //   };

  //   window.addEventListener("resize", handleResize);

  //   // Call the handleResize initially to set the initial state
  //   handleResize();

  //   // Cleanup event listener on unmount
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);
  return (
    <div className="min-h-screen flex-col justify-center items-center">
      {/* <div>About</div> */}
      <Seo
        title="About Us - Infosec Media"
        description="Learn more about Infosec Media, a leading provider of computer sales, service, and corporate rentals."
        keywords="Infosec Media, about us, computer sales, computer service"
      />
      <h1 className="text-4xl font-bold text-center text-cs3 mt-8 mb-2">
        A Legacy of Trust
      </h1>
      <div className="flex items-center justify-center">
        <hr className="h-2 w-2/4 border-cs4 pb-1" />
      </div>
      <div>
        <div className="flex flex-col md:flex-row items-center justify-center">
          <div className="h-4/6 mt-6">
            <img
              src={bannerImage}
              alt="company banner"
              className="rounded-3xl"
            />
          </div>
          <div className="md:pl-14 p-4 md:w-3/4  ">
            <h1 className="text-3xl font-semibold text-center text-cs3 mt-12 mb-2">
              {/* Our Story */}
            </h1>

            <div className="flex items-center justify-center">
              {/* <hr className="h-2 w-3/4 border-cs4 mb-4" /> */}
            </div>
            <div className=" justify-center">
              <p className="text-cs1 text-base ">
                Randeva Advisory Services Pvt Ltd is a Private Limited establishment with over 15 years of experience in the recovery and collection sector. 
              </p>
              <p className="text-cs1 text-base">
                <br />We pride ourselves on being a "humble yet potent" partner, handling complex contractual assignments with maturity and<br/> deep-rooted ground experience.
              </p>
              <p className="text-cs1 text-base">
                <br /> Our Core Philosophy: We believe in a "dignified and clean" operational approach.  Our motto is built on:
              </p><br/>
              <div className="text-cs1 text-base">
  <ul className="list-disc list-outside ml-5 space-y-2">
    <li>
      <b>Prompt & Judicious Handling:</b> Efficiently managing every assignment.
    </li>
    <li>
      <b>Honesty & Sympathy:</b> Maintaining a professional yet human touch in customer service.
    </li>
    <li>
      <b>Integrity:</b> A team of energetic and honest professionals dedicated to sustainable service.
    </li>
  </ul>
</div>
              
              <br />
            </div>
          </div>
        </div>
      </div>

      <div className=" flex item-center justify-center md:pt-6 pt-8 md:mt-16 pb-4">
        <div className="animated-gradient w-5/6 md:rounded-full rounded-3xl flex-col item-center justify-center md:h-28 h-20">
          <div className="text-white  flex items-center justify-center pt-6 md:text-4xl text-base text-center">
            We Provide the Best Service in Industry
          </div>
          <div className="text-white flex items-center justify-center md:pt-5 h-18">
            <button
              className="md:w-48 pt-3 pb-3 bg-cs1 flex font-semibold items-center justify-between px-4 rounded-full allproduct hover:bg-cs4"
              onClick={() => handleNavItemClick("contact")}
            >
              <div className="flex items-center justify-between w-full">
                <div className="ml-2 flex-nowrap">Contact Us Today</div>
                <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    style={{ fill: "white" }}
                    viewBox="0 0 32 32"
                    id="arrow"
                  >
                    <path d="M4 15a1 1 0 0 0 1 1h19.586l-4.292 4.292a1 1 0 0 0 1.414 1.414l6-6a.99.99 0 0 0 .292-.702V15c0-.13-.026-.26-.078-.382a.99.99 0 0 0-.216-.324l-6-6a1 1 0 0 0-1.414 1.414L24.586 14H5a1 1 0 0 0-1 1z"></path>
                  </svg>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Services  */}
      <div className="bg-cs2 rounded-xl pl-4 pr-4 pb-4">
        <h1 className="text-2xl font-bold text-center text-cs7 mt-20 pt-6 mb-4">
          Core Expertise
        </h1>
        <div className="flex items-center justify-center">
          <hr className="h-2 w-2/4 border-cs7 pb-4" />
        </div>

        {/* Services list */}
        <div className="flex flex-col sm:flex-row space-y-5 sm:space-y-0 sm:space-x-4 p-4 items-center justify-center">
          <button
            className="flex-grow"
          >
            <div className="max-w-full sm:max-w-sm rounded-xl overflow-hidden shadow-lg bg-cs5 service transition duration-300 ease-in-out md:contrast-75 hover:contrast-100">
              <img
                className="w-full h-48 object-cover"
                src={imgpurchase}
                alt="Dues Collection & Recovery"
              />
              <div className="px-6 py-4">
                <div className="font-bold text-xl text-cs3 mb-2">
                  Dues Collection & Recovery
                </div>
                <p className="text-cs1 text-base">
                  Specialized management of high-volume debt portfolios for MNC Banks and NBFCs with a focus on sustainable results.
                </p>
              </div>
              <div className="px-6 pt-1 pb-2">
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag1
                </span>
                <span className="inline-block  bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag2
                </span>
                {/* <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                #tag3
              </span> */}
              </div>
            </div>
          </button>

          <button
            className="flex-grow"
          >
            <div className="max-w-full sm:max-w-sm rounded-xl overflow-hidden shadow-lg bg-cs5 service transition duration-300 ease-in-out md:contrast-75 hover:contrast-100">
              <img
                className="w-full h-48 object-cover"
                src={imgslider2}
                alt="Contact Point Verification"
              />
              <div className="px-6 py-4">
                <div className="font-bold text-cs3 text-xl mb-2">
                  Contact Point Verification
                </div>
                <p className="text-cs1 text-base">
                  Deep-rooted field experience in verifying customer credentials to ensure data integrity for banking partners.
                </p>
              </div>
              <div className="px-6 pt-1 pb-2">
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag1
                </span>
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag2
                </span>
                {/* <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                #tag3
              </span> */}
              </div>
            </div>
          </button>

          <button
            className="flex-grow"
          >
            <div className="max-w-full sm:max-w-sm rounded-xl overflow-hidden shadow-lg bg-cs5 service transition duration-300 ease-in-out md:contrast-75 hover:contrast-100">
              <img
                className="w-full h-48 object-cover"
                src={imgrepair}
                alt="Strategic Advisory"
              />
              <div className="px-6 py-4">
                <div className="font-bold text-cs3 text-xl mb-2">
                  {" "}
                  Strategic Advisory
                </div>
                <p className="text-cs1 text-base">
                  Leveraging 15 years of industry maturity to offer judicious and prompt handling of complex contractual assignments.
                </p>
              </div>
              <div className="px-6 pt-1 pb-2">
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag1
                </span>
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag2
                </span>
                {/* <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                #tag3
              </span> */}
              </div>
            </div>
          </button>

          <button
            className="flex-grow"
          >
            <div className="max-w-full sm:max-w-sm rounded-xl overflow-hidden shadow-lg bg-cs5 service transition duration-300 ease-in-out md:contrast-75 hover:contrast-100">
              <img
                className="w-full h-48 object-cover"
                src={amcImage}
                alt="Turnover Excellence"
              />
              <div className="px-6 py-4">
                <div className="font-bold text-cs3 text-xl mb-2">
                  Turnover Excellence
                </div>
                <p className="text-cs1 text-base">
                  Consistently exceeding targets with a monthly recovery proximity of 85% or above.
                </p>
              </div>
              <div className="px-6 pt-1 pb-2">
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag1
                </span>
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag2
                </span>
                {/* <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                #tag3
              </span> */}
              </div>
            </div>
          </button>
        </div>
      </div>

      {/* <div className=" flex item-center justify-center pt-12 pb-4">
        <div className="animated-gradient w-full md:rounded-full rounded-3xl flex-col item-center justify-center">
          <div className="text-white  flex items-center justify-center pt-8  md:text-4xl text-base text-center">
            We Provide the Best Service in Industry
          </div>
          <div className="text-white flex items-center justify-center md:pt-5 pt-1">
            <button
              className="md:w-48 pt-3 pb-3 bg-cs1 flex font-semibold items-center justify-between px-4 rounded-full allproduct hover:bg-cs4 "
              onClick={() => handleNavItemClick("Contact")}
            >
              <div className="flex items-center justify-between w-full">
                <div className="ml-2">Contact Us Today</div>
                <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    style={{ fill: "white" }}
                    viewBox="0 0 32 32"
                    id="arrow"
                  >
                    <path d="M4 15a1 1 0 0 0 1 1h19.586l-4.292 4.292a1 1 0 0 0 1.414 1.414l6-6a.99.99 0 0 0 .292-.702V15c0-.13-.026-.26-.078-.382a.99.99 0 0 0-.216-.324l-6-6a1 1 0 0 0-1.414 1.414L24.586 14H5a1 1 0 0 0-1 1z"></path>
                  </svg>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div> */}

      <div className=" h-6 bg-cs5">
        {/* Your content goes here */}
        &nbsp; &nbsp;
      </div>
    </div>
  );
};

export default About;


